import React, { useState, useEffect } from 'react';
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { DatePicker } from 'antd'
import { _doGetDeliveryEfficiencyData, _doGetDeliveryEfficiencyReport } from './actions/DeliveryEfficiencyService';
import * as XLSX from 'xlsx';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
const { Option } = Select;

const DeliveryEfficiency = () => {
    const title = "Delivery Efficiency Dashboard";
    const dispatch = useDispatch();
    const [Efficiency, setEfficiencyValues] = useState([])
    const Stateslist = useSelector(state => state?.DeliveryEfficiency?.DeliveryEfficiencyData?.StatesList)
    const citylist = useSelector(state => state?.DeliveryEfficiency?.DeliveryEfficiencyData?.CityList)
    const storeslist = useSelector(state => state?.DeliveryEfficiency?.DeliveryEfficiencyData?.StoresList)
    const EfficiencyValues = useSelector(state => state?.DeliveryEfficiency?.DeliveryEfficiencyReport?.DeliveryEfficiencyValues)
    const EfficiencyList = useSelector(state => state?.DeliveryEfficiency?.DeliveryEfficiencyReport?.DeliveryEfficiencyList)
    const [cityData, setcityData] = useState([])
    const [storeData, setstoreData] = useState([])
    const [DeliveryEfficiencyData, setDeliveryEfficiencydata] = useState({
        fromdate: '',
        todate: '',
        storeid: [],
        storecity: []
    })

    const exportToExcel = (efficiencyValues=[], efficiencyList=[]) => {
        const wb = XLSX.utils.book_new();
      
        // Exporting Delivery Efficiency Report sheet
        const wsData1 = [
          ['Total Boxes', 'Total Qty', 'No.of Team Members', 'Total Time taken for Delivery(MIN)',
           'Total Human Hours Invested (Hrs)', 'Delivery Efficiency Per Person/Per Minute', 'Targeted efficiency', 'Win on Efficiency(Hr)'],
          [efficiencyValues[0]?.no_of_boxes, efficiencyValues[0]?.total_quantity, efficiencyValues[0]?.total_teammates,
          parseFloat(efficiencyValues[0]?.total_time_taken).toFixed(0), efficiencyValues[0]?.total_human_hours, efficiencyValues[0]?.delivery_efficiency_person,
          efficiencyValues[0]?.target_efficiency, efficiencyValues[0]?.win_on_efficiency]
        ];
        const ws1 = XLSX.utils.aoa_to_sheet(wsData1);
        XLSX.utils.book_append_sheet(wb, ws1, 'Delivery Efficiency Report');
      
        // Exporting Delivery Efficiency List sheet
        const wsData2 = [
          ['DATE', 'State', 'City', 'Store', 'Cost Center', 'DAY', 'DAILY MANAGER', 'NUMBER OF BOXES', 'QUANTITY',
           'No. of Team Members available for delivery', 'Total time taken for delivery(MIN)', 'TOTAL HUMAN HOURS INVESTED (Hrs)',
           'Delivery Efficiency Per Person/Per Minute', 'Targeted efficiecncy', 'Win on Efficiency(Hr)', 'Comments'],
          ...efficiencyList.map(item => [
            item.start_time, item.state_name, item.city_name, item.store_name, item.store_costcenter, item.day_of_week_new,
            item.daily_manager_name, item.no_of_boxes, item.total_quantity, item.total_teammates, item.total_time_taken,
            item.total_human_hours, item.delivery_efficiency_person, item.target_efficiency, item.win_on_efficiency, item.comments
          ])
        ];
        const ws2 = XLSX.utils.aoa_to_sheet(wsData2);
        XLSX.utils.book_append_sheet(wb, ws2, 'Delivery Efficiency List');
      
        XLSX.writeFile(wb, 'DeliveryEfficiencyReport.xlsx');
      };

    useEffect(() => {
        dispatch(_doGetDeliveryEfficiencyData());
        setEfficiencyValues(Efficiency)
    }, [])

    const _filtercitydata = (value) => {
        var cityData = [];
        setstoreData([]);
        setDeliveryEfficiencydata({ ...DeliveryEfficiencyData, storecity: [], storeid: [] })
        for (let i = 0; i < value.length; i++) {
            let fetchedData = citylist?.filter(ele => ele.store_state == value[i]).map(data => cityData.push(data))
        }
        setcityData(cityData);
    }

    const _filterstoredata = (value) => {
        var storeData = [];
        setstoreData([]);
        DeliveryEfficiencyData.storeid = [];
        setDeliveryEfficiencydata({ ...DeliveryEfficiencyData, storecity: value, storeid: [] })
        for (let i = 0; i < value.length; i++) {
            let fetchedData = storeslist?.filter(ele => ele.store_city == value[i]).map(data => storeData.push(data))
        }
        setstoreData(storeData);
    }

    const _displayDashboardData = () => {
        dispatch(_doGetDeliveryEfficiencyReport(DeliveryEfficiencyData))
    }
    function disabledDate(current) {
     
        let date = dayjs(DeliveryEfficiencyData.fromdate, 'DD-MM-YYYY').subtract(1, 'day');
        return current && current < date.endOf('day');
      }
    return (
        <div className="wrapper">
            <Header title={title} />
            <Menu1 />
            <div className='content-wrapper'>
                <section className="content">
                    <div className="m-panel mt-10">
                        <div className="m-panel__body p10 pb-10">
                            <div className="row">
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="exampleInput">
                                            From Date
                                        </label>
                                        <DatePicker
                                            onChange={(date, dateString) => setDeliveryEfficiencydata({ ...DeliveryEfficiencyData, fromdate: dateString })}
                                            size={12} format={'DD-MM-YYYY'} className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="exampleInput">
                                            To Date
                                        </label>
                                        <DatePicker
                                            disabledDate={disabledDate}
                                            onChange={(date, dateString) => setDeliveryEfficiencydata({ ...DeliveryEfficiencyData, todate: dateString })}
                                            size={12} format={'DD-MM-YYYY'} className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group select_h150">
                                        <label htmlFor="exampleInput">
                                            State
                                        </label>
                                        <Select
                                            className="form-control"
                                            showSearch
                                            onChange={(value) => (setDeliveryEfficiencydata({ ...DeliveryEfficiencyData, storestate: value }), _filtercitydata(value))}
                                            mode="multiple"
                                            placeholder="--Select All--"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >

                                            {
                                                Stateslist?.map(((item, index) =>
                                                    <Option key={index} value={item.store_state}>{item.state_name}</Option>
                                                ))
                                            }

                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group select_h150">
                                        <label htmlFor="exampleInput">
                                            City
                                        </label>
                                        <Select
                                            className="form-control"
                                            showSearch
                                            onChange={(value) => (setDeliveryEfficiencydata({ ...DeliveryEfficiencyData, storecity: value }), _filterstoredata(value))}
                                            mode="multiple"
                                            placeholder="--Select All--"
                                            value={DeliveryEfficiencyData.storecity}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {
                                                cityData?.map(((item, index) =>
                                                    <Option key={index} value={item.store_city}>{item.city_name}</Option>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group select_h150">
                                        <label htmlFor="exampleInput">
                                            Store Name
                                        </label>
                                        <Select
                                            className="form-control"
                                            onChange={(value) => setDeliveryEfficiencydata({ ...DeliveryEfficiencyData, storeid: value })}
                                            showSearch
                                            mode="multiple"
                                            placeholder="--Select All--"
                                            value={DeliveryEfficiencyData.storeid}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {
                                                storeData?.map(((item, index) =>
                                                    <Option key={index} value={item.store_id}>{item.store_name}</Option>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-2 btn-no-lbl">
                                    <button onClick={() => _displayDashboardData()} className='btn btn-secondary deca-btn-yellow'>
                                        Generate
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='m-panel__del_efficiency'>
                        <div className='m-panel__del_efficiency_content p10 pb-10'>
                            <div className='row del_efficiency_excel'>
                                <div className="col-md-12 text-right">
                                <button
                                className='btn btn-secondary deca-btn-yellow'
                                onClick={() => exportToExcel(EfficiencyValues, EfficiencyList)}
                                >
                                Export to Excel
                                </button>
                                </div>
                            </div>
                            <div className='delivery_efficiency'>
                                <div className='mt-10'>
                                    <div className='col-md-3 text-center p10'>
                                        <div className='del_effncy_count'>
                                            <h3>{EfficiencyValues && EfficiencyValues[0]?.no_of_boxes}</h3>
                                            <h5>Total Boxes</h5>
                                        </div>
                                    </div>
                                    <div className='col-md-3 text-center p10'>
                                        <div className='del_effncy_count'>
                                            <h3>{EfficiencyValues && EfficiencyValues[0]?.total_quantity}</h3>
                                            <h5>Total Qty</h5>
                                        </div>
                                    </div>
                                    <div className='col-md-3 text-center p10'>
                                        <div className='del_effncy_count'>
                                            <h3>{EfficiencyValues && EfficiencyValues[0]?.total_teammates}</h3>
                                            <h5>No.of Team Members</h5>
                                        </div>
                                    </div>
                                    <div className='col-md-3 text-center p10'>
                                        <div className='del_effncy_count'>
                                            <h3>{EfficiencyValues && parseFloat(EfficiencyValues[0]?.total_time_taken).toFixed(0)}</h3>
                                            <h5>Total Time taken for Delivery(MIN)</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='delivery_efficiency_val'>
                                <div className='row'>
                                    <div className='col-md-3'>
                                        <div className='card del_efficiency'>
                                            <div className='card-body'>
                                                <p className='card-title'>Total Human Hours Invested (Hrs)</p>
                                                <div className="card-content">
                                                    <h3>{EfficiencyValues && EfficiencyValues[0]?.total_human_hours}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className='card del_efficiency'>
                                            <div className='card-body'>
                                                <p className='card-title'>Delivery Efficiency Per Person/Per Minute</p>
                                                <div className="card-content">
                                                    <h3 style={{color:EfficiencyValues && EfficiencyValues[0]?.delivery_efficiency_person <6 ? 'red':'black'}}>{EfficiencyValues && EfficiencyValues[0]?.delivery_efficiency_person}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className='card del_efficiency'>
                                            <div className='card-body'>
                                                <p className='card-title'>Targeted efficiency</p>
                                                <div className="card-content">
                                                    <h3>{EfficiencyValues && EfficiencyValues[0]?.target_efficiency.toFixed(1)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className='card del_efficiency'>
                                            <div className='card-body'>
                                                <p className='card-title'>Win on Efficiency(Hr)</p>
                                                <div className="card-content">
                                                    <h3 style={{color:EfficiencyValues &&EfficiencyValues[0]?.win_on_efficiency <0 ? 'red':'black'}}>{EfficiencyValues && EfficiencyValues[0]?.win_on_efficiency}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default DeliveryEfficiency